import cn from 'classnames';
import Image from 'next/legacy/image';
import { Icon } from 'ht-styleguide';

/* Components */
import FirstServiceDiscountCode from '@components/Modals/FirstServiceDiscount/FirstServiceDiscountCode';
import FirstServiceDiscountDisclaimer from '@components/Modals/FirstServiceDiscount/FirstServiceDiscountDisclaimer';
/* Styles */
import styles from '../firstservicediscount.module.scss';

/*
 * This are the internals for the display. Inevitably, this will be used in the
 * base model for firstDiscount, but its' also a modal on its own.
 * */
const BASE_SAVING = '$10';

const ThankYouContent = ({ code, close }: { code: string; close: BaseAnyFunction }) => (
  <div className={styles.dialog}>
    <div className={styles.firstServiceDiscountModal}>
      <Icon name="close" className={styles.close} onClick={close} />
      <div className={styles.firstServiceDiscountModalLeft}>
        <div className={styles.firstServiceDiscountThankYou}>
          <div className={styles.firstServiceDiscountThankYouTitle} data-testid="first-discount-thankyou-title">
            Thank You!
          </div>
          <div className="h4">Book now and save instantly.</div>
          <p data-testid="first-discount-thankyou-note" className={cn('p1', styles.firstServiceDiscountThankYouPromo)}>
            Use the promo code below to receive {BASE_SAVING} off your first order. We&apos;ll also send you an email in case you decide to use it
            later.
          </p>
          <FirstServiceDiscountCode code={code} />
          <FirstServiceDiscountDisclaimer planName="HelloTech Home" />
        </div>
      </div>
      <div className={styles.firstServiceDiscountModalRight}>
        <Image
          quality={50}
          layout="responsive"
          width={340}
          height={395}
          src="/_nextassets_/images/house_with_pointsofinterest.jpg"
          className={styles.firstServiceDiscountModalImage}
          alt={`Save ${BASE_SAVING} Off`}
        />
      </div>
    </div>
  </div>
);

export default ThankYouContent;
